/* =========================================================
   Hydrizm LP – FAQアコーディオン
   <details> の開閉に高さアニメーションを付ける。
   JSが動かない環境でもネイティブの開閉として機能する。
   ========================================================= */
(function () {
  'use strict';

  var DUR = 280;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  function reduced() {
    return window.matchMedia &&
           window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setup(item) {
    if (item.dataset.hzFaqReady === '1') return;
    item.dataset.hzFaqReady = '1';

    var summary = item.querySelector('summary');
    var panel = item.querySelector('.hz-faq__a');
    if (!summary || !panel) return;

    var anim = null;

    function animate(from, to, done) {
      if (anim) anim.cancel();
      panel.style.overflow = 'hidden';
      anim = panel.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: DUR, easing: EASE }
      );
      anim.onfinish = function () {
        anim = null;
        panel.style.overflow = '';
        panel.style.height = '';
        if (done) done();
      };
      anim.oncancel = function () { anim = null; };
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (reduced()) { item.open = !item.open; return; }

      if (item.open) {
        var h = panel.offsetHeight;
        animate(h, 0, function () { item.open = false; });
      } else {
        item.open = true;
        var target = panel.offsetHeight;
        animate(0, target);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.hz-faq__item').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
